<template>
    <div class="card card-default card-sm">
        <div class="card-header">
            <h4>تکمیل اطلاعات حساب کاربری</h4>
            <p>لطفا جهت تکمیل سفارش خود اطلاعات ذیل را وارد نمایید.</p>
        </div>
        <div class="card-body">
            <form v-bind:action="requestUri" @submit.prevent="submit(requestUri,'put')" method="post">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                            <SimpleText :errors="errors" name="first_name" v-model="form.first_name" label="نام" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                            <SimpleText :errors="errors" name="last_name" v-model="form.last_name" label="نام خانوادگی" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                            <SimpleText :errors="errors" name="phone" v-model="form.phone" label="تلفن" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                            <SimpleText :errors="errors" :model-value="user.mobile" disabled name="mobile" label="موبایل" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                            <SimpleSelect name="province_id" :errors="errors" label="استان" v-model="form.province_id" :options="provinces" :class="{loading: gettingProvinces}" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                            <SimpleSelect name="city_id" :errors="errors" label="شهر" v-model="form.city_id" :options="cities" :class="{loading: gettingCities}" />
                        </div>
                    </div>
                    <div class="form-group mb-3">
                        <SimpleTextarea :errors="errors" name="address" v-model="form.address" label="آدرس" />
                    </div>
                    <div class="form-group mb-3">
                        <SimpleText :errors="errors" name="postalcode" v-model="form.postalcode" label="کد پستی" />
                    </div>
                </div>
                <button class="btn btn-primary" type="submit" :disabled="loading">
                    <span>ذخیره تغییرات</span>
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import simpleAjaxForm from '../general/SimpleAjaxFormMixin';

export default {
    name: "CompleteProfile",
    mixins: [simpleAjaxForm],
    data: () => ({
        form: {
            first_name: '',
            last_name: '',
            phone: '',
            province_id: '',
            city_id: '',
            address: '',
            postalcode: ''
        },
        gettingProvinces: false,
        provinces: [],
        gettingCities: false,
        cities: [],
    }),
    computed: {
        user() {
            return this.getUser();
        },
        provinceId() {
            return this.form.province_id;
        },
        requestUri() {
            return this.route('api.profile.completion')
        },
    },
    watch: {
        provinceId(value) {
            this.getCities(value);
        }
    },
    methods: {
        getProvinces() {
            this.gettingProvinces = true;
            this.axios.get(this.route('api.provinces')).then(response => {
                this.provinces = response.data.data.map(province => {
                    return {
                        key: province.id,
                        value: province.name
                    };
                });
                this.gettingProvinces = false;
            }).catch(async error => {
                this.gettingProvinces = false;
            });
        },
        getCities(province_id) {
            this.gettingCities = true;
            this.axios.get(this.route('api.cities', [province_id])).then(response => {
                this.cities = response.data.data.map(city => {
                    return {
                        key: city.id,
                        value: city.name
                    };
                });
                this.gettingCities = false;
            }).catch(async error => {
                this.gettingCities = false;
            });
        },
        successful(response) {
            this.$store.commit('user/setUser', response.data.data);
        }
    },
    mounted() {
        this.getProvinces();
    }
}
</script>

<style scoped>

</style>
